import { createSlice } from "@reduxjs/toolkit";

// Who is signed in. The token and the user shape { id, role, organizationId,
// name, phone, email } both live in localStorage so a reload keeps the
// session; the role is what decides portal vs CMS routes.

const CUSTOMER_ROLES = ["CUST_ADMIN", "CUST_MANAGER", "CUST_APPROVER", "CUST_ACCOUNTS"];

function readUser() {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
}

const initialState = {
  isAuthenticated: !!localStorage.getItem("token"),
  user: readUser(),
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLogin: (state, action) => {
      state.isAuthenticated = true;
      if (action.payload.user) {
        state.user = action.payload.user;
        localStorage.setItem("user", JSON.stringify(action.payload.user));
      }
    },
    setUser: (state, action) => {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
    },
    setLogout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
    },
  },
});

export const { setLogin, setUser, setLogout } = authSlice.actions;
export const isCustomerRole = (role) => CUSTOMER_ROLES.includes(role);
export const homeFor = (user) => (user && isCustomerRole(user.role) ? "/portal" : "/dashboard");
export default authSlice.reducer;
